import { render, staticRenderFns } from "./singleSet.vue?vue&type=template&id=32eb8be5&scoped=true"
import script from "./singleSet.vue?vue&type=script&lang=js"
export * from "./singleSet.vue?vue&type=script&lang=js"
import style0 from "./singleSet.vue?vue&type=style&index=0&id=32eb8be5&prod&lang=less&scoped=true"
import style1 from "./singleSet.vue?vue&type=style&index=1&id=32eb8be5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eb8be5",
  null
  
)

export default component.exports